import script from "./onlineConsult.vue?vue&type=script&setup=true&lang=js"
export * from "./onlineConsult.vue?vue&type=script&setup=true&lang=js"

import "./onlineConsult.vue?vue&type=style&index=0&id=fbf8cce6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fbf8cce6"]])

export default __exports__